
var Conversation = function(options){
    var _self = this;
    this.defaults = {
        selector: null
    }
    this.settings = $.extend({}, this.defaults, options);

    //Bind
    if(_self.settings.selector != null){
        if( $(_self.settings.selector).find('form').length > 0 ){
            _self.BindForm();
        }
    }
    return _self;
}

Conversation.prototype.BindForm = function() {
    var _self = this;
    var $form = $("form",_self.settings.selector)

    $form.submit(function(event) {
        event.preventDefault();
        if( $.trim( $("textarea[name=comment]", $form).val() ).length > 0 ) {
            //create
            var endpoint = $form.attr('action');
            var data = $form.serializeObject();
            httpPost(endpoint, data).then(
                function(value){
                    var response = JSON.parse(value);
                    console.log(response);
                    alertify.success('Comment Added');
                    $("textarea[name=comment]", $form).val("");
                    $(".conversation-empty",_self.settings.selector).remove();
                    _self.AddComment(response);
                })
            .catch(
                function(reason) {
                    console.error(JSON.parse(reason));
                    alertify.error('Unable to Add Comment');
                });

        }
    });

}

Conversation.prototype.AddComment = function(comment) {
    var _self = this;
    var $items = $(".conversation-items",_self.settings.selector);
    var hbstemplate = mantlhbs.comment;
    var output = hbstemplate(comment);
    $items.append(output);
    _self.FormatTimes();
}

Conversation.prototype.FormatTimes = function() {
    var _self = this;
    var $items = $(".conversation-item",_self.settings.selector);

    var format = '[on] MMM Do, YYYY [at] HH:mm';

    $("time",$items).each(function(){
        var timestamp = new Date($(this).attr("datetime"));
        $(this).text( fecha.format(timestamp, format) );
    });
}
